import { makeStyles } from '@mui/styles'

export default makeStyles(() => ({
    CommonDatePicker: {
        display: 'flex',
        justifyContent: 'flex-start',
        alignItems: 'center',
        gap: '1rem',
    },
    CommonDatePickerField: {
        flex: 1,
    },
}))
